import { StylableTableCellMui } from "../nodes/stylable-table-cell-mui";

import type { EmailLayoutSettings } from "../../../email-design/types/email-layout-type";
import type { LexicalEditorNodes } from "../lexical-editor-wrapper";

// Unfortunately a very loose type but better to have a single source.
export type StyleableColumnConfig = Partial<
  Pick<
    EmailLayoutSettings,
    | "column_padding_bottom"
    | "column_padding_left"
    | "column_padding_right"
    | "column_padding_top"
    | "column_individual_padding"
    | "column_padding"
  >
>;

export type TableCellNodeSupercedement = (nodes: LexicalEditorNodes) => LexicalEditorNodes;

export const tableNodeReplacement = (nodes: LexicalEditorNodes): LexicalEditorNodes => {
  const hasTableCellNode = nodes.some(
    (node) => "getType" in node && node.getType() === "tablecell",
  );
  // Only if the channel already allows tablecells and we have the flag enabled
  if (!hasTableCellNode) {
    return nodes;
  }

  const emailNodes = nodes.filter((node) => "getType" in node && node.getType() !== "tablecell");
  return emailNodes.concat(StylableTableCellMui);
};
